import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit, OnChanges {
  @Input() rating: any = 0;
  @Input() itemId: any = 0;
  @Input() allowClick: any;
  @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

  inputName: string = '';
  disableSubmit: boolean;
  ngOnInit() {
    this.inputName = this.itemId + '_rating';
    this.fixRating();
  }
  fixRating() {
    if (this.rating) {
      this.rating = Math.round(this.rating);
    }
    if(this.rating == 0){
      this.disableSubmit = true;
    }
    else this.disableSubmit = false;
  }
  ngOnChanges(changes: any) {
    if (
      changes['rating'] &&
      changes['rating'].previousValue !== undefined &&
      !changes['rating'].isFirstChange()
    ) {
      this.rating = changes['rating'].currentValue;
      this.fixRating();
    }

  }
  onClick(rating: number): void {
    if (this.allowClick) {
      this.rating = rating;
      this.ratingClick.emit({
        itemId: this.itemId,
        rating: rating,
        disableSubmit : this.disableSubmit
      });
    }
  }
}
